import { Button, Typography } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

/** Descarga la definición OpenAPI para importarla en Postman o Bruno y probar la API desde la máquina del dev. */
export const ApiDownloadCard = () => {
  const { entity } = useEntity();
  const definition = String(entity.spec?.definition ?? '');
  if (entity.spec?.type !== 'openapi' || !definition) return null;

  let isJson = true;
  try {
    JSON.parse(definition);
  } catch {
    isJson = false;
  }
  const file = `${entity.metadata.name}.openapi.${isJson ? 'json' : 'yaml'}`;
  const download = () => {
    const url = URL.createObjectURL(new Blob([definition], { type: isJson ? 'application/json' : 'application/yaml' }));
    const a = Object.assign(document.createElement('a'), { href: url, download: file });
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <InfoCard title="Probar esta API">
      <Button variant="contained" color="primary" startIcon={<GetAppIcon />} onClick={download}>
        Descargar {file}
      </Button>
      <Typography variant="body2" style={{ marginTop: 12 }}>
        <b>Postman:</b> Import → arrastra el archivo. <b>Bruno:</b> Import Collection → OpenAPI V3 → elige el archivo.
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
        Las llamadas salen desde tu máquina con tus accesos a QA; Backstage no las ejecuta. Nunca apuntes a producción.
      </Typography>
    </InfoCard>
  );
};
